// this component is handling the search form on the header
import {
  addSearchTag,
  removeSearchTag,
  selectSearchTags,
  selectSearchValue,
  setSearchByTags,
  setSearchTagsOpenFrom,
  setSearchValue,
} from '../../redux/slicers/search/searchSlicer';
import { SearchInput } from '..';
import { useDispatch, useSelector } from 'react-redux';
import { memo, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import styles from './UniversalSearchForm.module.scss';
import { apiGetCommonGlobalTags } from '../../helpers/api';
import { CLOSE_ICON } from '../../constants/assetConstants';
import Image from '../Image'
import { GlobalDefaultSearchTagsFilter, GlobalSearchTagsFilter } from '../GlobalFilter';
import SearchBar from '../../components/admin/curator/SearchBar/SearchBar';
import { resetFilters, setDoFilterUpdateValue } from '../../redux/slicers/admin/sidebarSlicer';
import { addUpdateParamsInSequence } from '../../redux/slicers/filters/filterSlicer';
import { MODE, useApiList } from '../../hooks/useApiList';
import InfiniteScroll from '../../components/InfiniteScroll/InfiniteScroll';
import { sendDataToFrappeApp } from '../../screens/Requests/RequestsV2';

export default function UniversalSearchForm({ className, isOtherMenuOpen }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const containerRef = useRef();
  const searchVal = useSelector(selectSearchValue);
  const location = useLocation();
  const routeParams = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [openTagsList, setOpenTagsList] = useState(false)
  const [localSearchVal, setLocalSearchVal] = useState(searchVal || '')

  useEffect(() => {
    if (searchVal !== localSearchVal) {
      setLocalSearchVal(searchVal)
    }
    if(isOtherMenuOpen) setOpenTagsList(false);
  }, [searchVal, isOtherMenuOpen])

  useEffect(() => {
    if(searchParams.get('tags')) return;
    setOpenTagsList(false)
    dispatch(setSearchByTags([]))
    dispatch(setSearchTagsOpenFrom(''))
  }, [location])

  const handleChange = (evt) => {
    setLocalSearchVal(evt.target.value);
    setOpenTagsList(true)
  }
  
  const handleKeyDown = (evt) => {
    if (evt.key === 'Enter') {
      const value = localSearchVal;
      const urlParams = new URLSearchParams();
      dispatch(setSearchValue(value))
      setOpenTagsList(false)
      urlParams.set('s', value )

      if (Object.keys(routeParams).length) {
        // for inner page -> for example when someone searched and opened render details -> we want to close render details 
        let parts = location.pathname.split('/')
        Object.values(routeParams).forEach(param => {
          parts = parts.filter(item => item !== param)
        })

        const pathname = parts.join('/');
        navigate(`${pathname}?${urlParams}`)

      } else {
        setSearchParams(urlParams)
      }
    }
  };

  const handleFocus = () => {
    setOpenTagsList(true)

    sendDataToFrappeApp({
      app_dropdown_opened: true,
    });
  }

  const handleClear = () => {
    setLocalSearchVal('');
    const params = new URLSearchParams();
    setSearchParams(params);
  }

  // Expose method to close dropdown programmatically
  useEffect(() => {
    if(!openTagsList) return;
    window.closeOpenedMenu = () => {
      setOpenTagsList(false);
    };
    return () => {
      delete window.closeOpenedMenu;
    };
  }, [openTagsList]);

  return (
    <>
      <div ref={containerRef} className={`w-100 search-wrapper ${className}`}>
        <SearchInput
          inputClassName={localSearchVal ? styles.inputNotEmpty : styles.input}
          value={localSearchVal}
          placeholder="Search"
          onChange={handleChange}
          onFocus={handleFocus}
          onClear={handleClear}
          onKeyDown={handleKeyDown}
        />
        {
          openTagsList
          &&
          <DropdownTagsList containerRef={containerRef} openFrom={'top'} search={localSearchVal} openTagsList={openTagsList} setOpenTagsList={setOpenTagsList} /> 
        }
      </div>
    </>
  );
}

export const PageSearchBar = ({ onSearchChange, search, model, hideTags = false , designV2 = null, className = "", imageSearchActive = false, onImageSearchClick = null, inputClassName="", searchBarClassName="", onBlur, autoFocus=false, triggerOnType=false }) => {

  const dispatch = useDispatch();
  const containerRef = useRef();
  const [openTagsList, setOpenTagsList] = useState(false)
  const [localSearchVal, setLocalSearchVal] = useState('')
  const handleFocus = () => {
    setOpenTagsList(true)
  }

  useEffect(() => {
    if (search !== localSearchVal) {
      setLocalSearchVal(search);
    }
  }, [search])

  const handleKeyDown = (evt) => {
    if (evt.key === 'Enter') {
      const value = localSearchVal;
      onSearchChange(value)
      setOpenTagsList(false)
      dispatch(setDoFilterUpdateValue(true));
    }
  };

  const handleChange = (evt) => {
    if (triggerOnType)
      onSearchChange(evt.target.value)
    setLocalSearchVal(evt.target.value);
    setOpenTagsList(true)
  }

  const handleClear = () => {
    setLocalSearchVal('');
    onSearchChange('');
    setOpenTagsList(false)
    dispatch(setDoFilterUpdateValue(true));
  }

  return (
    <>
      <div ref={containerRef} className={`universal_search ${className}`} style={{ position: 'relative' }}>
        <div className={`${searchBarClassName} pg_searchbar`}>
          <SearchBar
            onChange={handleChange}
            placeholder="Search"
            onFocus={handleFocus}
            value={localSearchVal}
            onKeyDown={handleKeyDown}
            onClear={handleClear}
            onBlur={onBlur}
            imageSearchActive={imageSearchActive}
            onImageSearchClick={onImageSearchClick}
            inputClassName={inputClassName}
            autoFocus={autoFocus}
          />
          {/* { !hideTags && <GlobalDefaultSearchTagsFilter model={model} /> } */}
        </div>
        { openTagsList && !hideTags && <DropdownTagsList containerRef={containerRef} model={model} openFrom={'page'} search={localSearchVal} openTagsList={openTagsList} setOpenTagsList={setOpenTagsList} /> }
      </div>
      {!hideTags && !designV2 && <GlobalSearchTagsFilter designV2={designV2}/> }
    </>
  )
}

export const DropdownTagsList = memo(({ containerRef, model, openFrom, search, openTagsList, setOpenTagsList, customClass, tagSelected = null }) => {
  const dispatch = useDispatch()
  const searchTags = useSelector(selectSearchTags);

  const hideDropdownTagsList = (e) => {
    if(e.type === "click" && containerRef.current && containerRef.current.contains(e.target)) return;
    setOpenTagsList(false);
  }
  
  useEffect(() => {
    
    window.addEventListener('keydown', hideDropdownTagsList)
    window.addEventListener('click', hideDropdownTagsList)

    return () => {
      window.removeEventListener('keydown', hideDropdownTagsList)
      window.removeEventListener('click', hideDropdownTagsList)
    }
  }, [])

  const {
    fetchNextPage,
    hasMore,
    hasData,
    list,
    loading,
    total,
  } = useApiList(
    {
      api: apiGetCommonGlobalTags,
      defaultPerPage: 20,
      mode: MODE.PARAMS,
      params: {
        model: model,
        tags: search,
      },
    },
    [search, openTagsList]
  );

  const handleSearchByTags = (tag) => {
    dispatch(resetFilters());

    if (searchTags.length && searchTags.includes(tag)) {
      dispatch(removeSearchTag(tag));
      return;
    }

    dispatch(addSearchTag(tag));
    if (tagSelected) {
      tagSelected(searchTags);
    } else {
      dispatch(setSearchTagsOpenFrom(openFrom));
      dispatch(addUpdateParamsInSequence({ tags: [...searchTags, tag] }));
    }
  };

  if (!openTagsList) return null;
  
  if(list?.length === 0) return null

  return (
    
    <div id="dropdownTagsList" className={`users-list-box popup-userlist-box dropdownTagsList ${customClass}`}
      style={{
        display: openTagsList ? 'block' : 'none',
      }}
    >
      <div className="d-flex align-items-center users-inner-list title">
        Choose tags:

        <button className='closeBtn' onClick={() => setOpenTagsList(false)}>
          <Image src={CLOSE_ICON} />
        </button>
      </div>
      <div className='innerlist' style={{ maxHeight: '300'}}>
        <InfiniteScroll
          dataLength={total}
          next={fetchNextPage}
          hasMore={hasMore}
          loading={loading}
          hasChildren={hasData}
          loadingType={null}
          scrollableTarget="infiniteScroll">
        {
          (!loading && list.length === 0)
          &&
          <div className="d-flex align-items-center users-inner-list">
            <p className="tag-name">No tags found.</p>
          </div>
        }
        {
          list.map(a => (
            <div key={a?.id}
              className={`d-flex align-items-center users-inner-list ${searchTags.includes(a.name) ? 'selected' : ''}`}
              onClick={(e) => handleSearchByTags(a.name)}>
              <p className="tag-name">{a.name}</p>
            </div>
          ))
        }
        </InfiniteScroll>
    </div>
  </div>
  )
})